<template>
  <div class="whitedark-bg pr">
    <div v-observe-visibility="backVisible" class="wi-2 transition-lenear ht-100x danger-bg pa tp-0 lf-0"></div>
    <div class="wrapper slogan-item pr" :style="screenWidth<=768?'margin-left:20px;margin-right:20px;':''">
      <el-row>
        <el-col :span="16" :lg="16" :md="24" :sm="24" :xs="24">
          <div ref="sloganTitle" class="tt-u white transition-gentle pr bm--50 fw-400 fs-14 op-0 mb-20" style="letter-spacing: 10px;">{{info.slogan_small_character}}</div>
          <div ref="sloganContext" class="serif white transition-gentle pr op-0 slogan-slogan fw-600">{{info.slogan}}</div>
        </el-col>
      </el-row>
      <div
        style="bottom: -166px;"
        v-observe-visibility="cardVisible"
        class="white-bg card-shadow transition-slow wi-2 pa rt-0 lf-0 mg-a" :class="screenWidth>768?'ht-340':'ht-320'">
        <el-row v-if="screenWidth>768">
          <el-col :span="14">
            <div class="wi-100x ht-340 op-0 transition-slow pr" ref="child1">
              <div class="dis-ib slogan-intro centerbox lh-26">
                <div class="pb-6">{{info.say_hello_en}}</div>
                <div>{{info.say_hello_zh}}</div>
              </div>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="wi-100x ht-340 op-0 transition-slow pr" ref="child2">
              <div class="dis-ib wi-340 ht-80 centerbox ta-c">
                <span :class="screenWidth<=1200?'title-default-text':'hover-text'" class="dis-ib slogan-item-title serif ta-c" @click="router('/contact')">
                  {{info.say_hello_title}}
                  <div :class="screenWidth<=1200?'':'hover-text-more'" class="default-font dis-ib fs-15 lh-16 pr lf--8">
                    <span v-if="screenWidth>=1920">联<br>系</span>
                    <span v-else class="pr bm-2 lf-4">联系</span>
                  </div>
                </span>
              </div>
            </div>
          </el-col>
        </el-row>
        <!-- 尺寸在768以下样式 -->
        <el-row v-else>
          <el-col :span="24">
            <div class="ht-190 of-a op-0 transition-slow pr" ref="child1">
              <div class="dis-ib slogan-intro pt-20 centerbox lh-26">
                <div class="ml-20 mr-20 fs-14 pb-6 op-8">{{info.say_hello_en}}</div>
                <div class="ml-20 mr-20 fs-14 op-8">{{info.say_hello_zh}}</div>
              </div>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="wi-100x ht-120 op-0 transition-slow pr" ref="child2">
              <div class="dis-ib wi-400 ht-60 centerbox ta-l">
                <span class="dis-ib slogan-item-title serif ta-l title-default-text ml-20" @click="router('/contact')">
                  {{info.say_hello_title}}
                  <div v-if="screenWidth>992" class="default-font dis-ib fs-15 pr lf--2">
                    联系
                  </div>
                  <div v-else class="default-font dis-ib fs-15 pr lf--2">
                    联系
                  </div>
                </span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Slogan',
  computed: {
    ...mapGetters([
      'sloganInfo',
      'screenWidth'
    ])
  },
  data () {
    return {
      info: {}
    }
  },
  watch: {
    sloganInfo (val) {
      if (val) {
        this.info = this.$.s2o(val)
        this.$.s('sloganInfo', val)
      }
    }
  },
  mounted () {
    // 不同
    if (this.$.g('sloganInfo')) {
      this.info = this.$.s2o(this.$.g('sloganInfo'))
    }
  },
  methods: {
    /*
    * 背景
    */
    backVisible (isVisible, entry) {
      if (isVisible) {
        entry.target.style.width = '100%'
        setTimeout(() => {
          this.$refs.sloganTitle.style.opacity = 1
          this.$refs.sloganTitle.style.bottom = 0
        }, 200)
        setTimeout(() => {
          this.$refs.sloganContext.style.opacity = 1
          this.$refs.sloganContext.style.bottom = 0
        }, 500)
      }
    },
    /*
    * 联系
    */
    cardVisible (isVisible, entry) {
      if (isVisible) {
        entry.target.style.width = '100%'
        if (this.screenWidth < 768) {
          this.$refs.child1.style.width = (this.screenWidth - 40) + 'px'
        } else {
          this.$refs.child1.style.width = '100%'
        }
        setTimeout(() => {
          this.$refs.child1.style.opacity = 1
          this.$refs.child2.style.opacity = 1
        }, 500)
      }
    }
  }
}
</script>
<style>
.slogan-slogan {
  bottom: -50px;
  font-size: 2.2em;
  padding-top: 10px;
}
.slogan-item-title {
  font-size: 1.8em;
  font-weight: 600;
}
.slogan-intro {
  max-width: 400px;
  font-size: 1em;
}
.slogan-item {
  padding-top: 4em;
  padding-bottom: 13.5em;
}
@media screen and (min-width: 768px) and (max-width: 992px) {
  .slogan-item-title {
    font-size: 28px;
    font-weight: 600;
  }
  .slogan-intro {
    width: 320px;
    height: 130px;
    font-size: 15px;
  }
  .slogan-slogan {
    bottom: -50px;
    font-size: 50px;
  }
  .slogan-item {
    padding-top: 90px;
    padding-bottom: 250px;
  }
}
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .slogan-item-title {
    font-size: 32px;
    font-weight: 600;
  }
  .slogan-intro {
    width: 400px;
    height: 130px;
    font-size: 14px;
  }
  .slogan-slogan {
    bottom: -50px;
    font-size: 55px;
  }
  .slogan-item {
    padding-top: 100px;
    padding-bottom: 270px;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1920px) {
  .slogan-item-title {
    font-size: 38px;
    font-weight: 600;
  }
  .slogan-intro {
    width: 400px;
    height: 130px;
    font-size: 14px;
  }
  .slogan-slogan {
    bottom: -50px;
    font-size: 65px;
  }
  .slogan-item {
    padding-top: 110px;
    padding-bottom: 280px;
  }
}
@media screen and (min-width: 1920px) {
  .slogan-item-title {
    font-size: 46px;
    font-weight: 600;
  }
  .slogan-intro {
    width: 400px;
    height: 130px;
    font-size: 16px;
  }
  .slogan-slogan {
    bottom: -50px;
    font-size: 70px;
  }
  .slogan-item {
    padding-top: 120px;
    padding-bottom: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/compos/Slogan.vue